import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { formatTime } from '@/core';

/** app store — 面包屑、数据刷新时间、动效降级（?static）。本端无告警角标：没有对应的告警返回点，不放常数 */
export const useAppStore = defineStore('app', () => {
  const crumb = ref('');
  const refreshedAt = ref<Date>(new Date());
  const sidebarCollapsed = ref(false);

  /** ?static 关闭动效：用于截图与低性能设备（原型同款降级开关） */
  const staticMode = computed(() => {
    const hash = window.location.hash || '';
    const search = window.location.search || '';
    return /[?&]static\b/.test(hash) || /[?&]static\b/.test(search);
  });

  function setCrumb(value: string): void {
    crumb.value = value;
  }

  function markRefreshed(at = new Date()): void {
    refreshedAt.value = at;
  }

  const refreshedText = computed(() => `数据更新于 ${formatTime(refreshedAt.value)}`);

  function toggleSidebar(): void {
    sidebarCollapsed.value = !sidebarCollapsed.value;
  }

  return { crumb, refreshedAt, refreshedText, sidebarCollapsed, staticMode, setCrumb, markRefreshed, toggleSidebar };
});
